import { Component, Input, Output, EventEmitter } from '@angular/core';


/**
   * Logger Factory
  
*/

@Component({
  selector: 'ute-rename-drawer',
  templateUrl: 'ute-rename-drawer.component.html'
})

export class UteRenameDrawer {
  @Input()  isDrawerOpen: boolean;
  @Input()  cancel: boolean = false;
  @Input()  cancelLabel: string;
  @Input()  action: string;
  @Input()  actionLabel: string;
  @Input()  title: string;
  
  @Output() isDrawerOpenChange = new EventEmitter;
  @Output() onClickAction = new EventEmitter;
  @Output() inputLabelValue = new EventEmitter;

  public privacyValid: boolean;
  public privacyItems: any;
  
  inputValue: '';
  
  constructor() {
 
  }

  ionViewDidLoad() {
   
  }
  
 
  onChangeDrawer(event){
    this.isDrawerOpenChange.emit(false);
  }
  onChangeInputLabel(event){
    this.inputLabelValue.emit(event);
  }



}


// WEBPACK FOOTER //
// ./src/app/user/components/ute-rename-drawer/ute-rename-drawer.component.ts